// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","rounded":"Button_rounded__-qIj8","btnCustom":"Button_btnCustom__9kfCI","btnLarge":"Button_btnLarge__pbWXg","octocat-wave":"Button_octocat-wave__0XHSz"};